module.exports = __webpack_public_path__ + "assets/shiyan.b27cff0f.svg";